module.exports = __webpack_public_path__ + "img/a1.15dded57.png";